<template>
	<AppHeader
		:logo="logo"
		:headerButton1="headerButton1"
		:headerButton2="headerButton2"
		hideBtn1
	/>
	<UiElement class="d-flex flex-column h-100 pb-0" :settings="appearance.body.settings">
		<div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
			<UiText :settings="heading1" class="text-center" :content="translations?.thankYou || '{thankYou}'" />
		</div>
	</UiElement>
</template>

<script setup>
	import { computed, onMounted } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import AppHeader from '@/components/AppHeader.vue';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';
	import { useIdleStore } from '@/stores/useIdleStore';

	const { cancelUsage } = useIdleStore();
	
	const themeStore = useThemeStore();
	const translationsStore = useTranslationsStore();

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);

	const page = computed(() => theme.value.pages.end);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));

	onMounted(() => {
		if (window.self === window.top) {
			setTimeout(() => {
				cancelUsage();
			}, 3000);
		}
	})
</script>